import type { Ranges } from 'api/System/types'
import { getDateKey } from 'data/utils'
import { moment } from 'locale'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import { FETCH_COMPANIES, FETCH_COMPANIES_DONE, FETCH_COMPANIES_ERROR, FETCH_COMPANIES_SUCCESS } from './constants'
import type { Companies as CompaniesState, Company } from './types'

interface ReducerAction extends Action {
  payload: {
    data: Company[]
    dateCurrent: RequestDate
    dateCompared?: RequestDate | null
    range: Ranges
  }
}

export default function Companies(state: CompaniesState = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_COMPANIES:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          isLoading: true,
        },
      }
    case FETCH_COMPANIES_DONE:
    case FETCH_COMPANIES_ERROR:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_COMPANIES_SUCCESS:
      return {
        ...state,
        [getDateKey(payload)]: {
          data: payload.data,
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    default:
      return state
  }
}
